import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import CodeBlock from './CodeBlock';

/**
 * Renders concept markdown. Fenced code blocks (```lang) go through
 * CodeBlock (syntax highlighting + copy button; mermaid fences become
 * diagrams); inline code stays as a plain <code>.
 */
const MarkdownRenderer = ({ markdown }: { markdown: string }) => {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        code(props) {
          const { className, children, ...rest } = props;
          const match = /language-(\w+)/.exec(className || '');
          if (match) {
            return <CodeBlock language={match[1]} value={String(children).replace(/\n$/, '')} />;
          }
          return (
            <code className={className} {...rest}>
              {children}
            </code>
          );
        },
      }}
    >
      {markdown}
    </ReactMarkdown>
  );
};

export default MarkdownRenderer;
